import { render, staticRenderFns } from "./approval_button.vue?vue&type=template&id=1ea285ac&scoped=true"
import script from "./approval_button.vue?vue&type=script&lang=js"
export * from "./approval_button.vue?vue&type=script&lang=js"
import style0 from "./approval_button.vue?vue&type=style&index=0&id=1ea285ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea285ac",
  null
  
)

export default component.exports